// extracted by mini-css-extract-plugin
export default {"errorWrapper":"SettingsError_errorWrapper__TT2+A"};